"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishModal = exports.SankeyDevMenuPublishItem = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyDevMenuPublishItem = (t, set_show_publish_dialog) => {
    return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => set_show_publish_dialog(true) }, t('Menu.pub'));
};
exports.SankeyDevMenuPublishItem = SankeyDevMenuPublishItem;
/**
 * Description placeholder
 *
 * @param {PublishModalTypes} { publishImpl,set_show_publish_dialog,file_path_initial }
 * @returns
 */
const PublishModal = ({ t, publishImpl, show_publish_dialog, set_show_publish_dialog, data }) => {
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show_publish_dialog, onHide: () => set_show_publish_dialog(false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('Menu.pdd'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, t('Menu.ca')),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', placeholder: data.file_name ? data.file_name : '', onChange: (evt) => data.file_name = evt.target.value }))))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => publishImpl(data.file_name) }, t('Menu.pub')),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => set_show_publish_dialog(false) }, t('Menu.ca')))));
};
exports.PublishModal = PublishModal;
